import React from 'react';
import { Tag } from 'antd';
import { PayrollStatus } from '../types';

const colorMap: Record<PayrollStatus, string> = {
  DRAFT: 'default',
  PENDING_APPROVAL: 'orange',
  APPROVED: 'blue',
  PROCESSED: 'cyan',
  PAID: 'green',
  CANCELLED: 'red',
};

const labelMap: Record<PayrollStatus, string> = {
  DRAFT: 'Draft',
  PENDING_APPROVAL: 'Pending Approval',
  APPROVED: 'Approved',
  PROCESSED: 'Processed',
  PAID: 'Paid',
  CANCELLED: 'Cancelled',
};

const PayrollStatusBadge: React.FC<{ status: PayrollStatus }> = ({ status }) => (
  <Tag color={colorMap[status]}>{labelMap[status]}</Tag>
);

export default PayrollStatusBadge;
